module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level7.c2162133.png";